module.exports = __webpack_public_path__ + "static/img/1000000491.4dc0158a.jpg";